import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackErrorsComponent } from './callback-errors/callback-errors.component';
import { ExternalLoginCallbackComponent } from './callback/callback.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'callback/success',
    component: ExternalLoginCallbackComponent,
  },
  {
    path: 'callback/errors',
    component: CallbackErrorsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
